import autocomplete from 'autocompleter'

export default class extends HTMLElement {
  connectedCallback () {
    autocomplete({
      input: this.input,
      preventSubmit: 1,
      minLength: 1,
      showOnFocus: true,
      debounceWaitMs: 200,
      onSelect: this.onSelect,
      render: this.render,
      fetch: this.fetch
    })
  }

  disconnectedCallback () {
    this.abortFetch()
  }

  onSelect = (item) => {
    const fields = ['email', 'name', 'phone']
    const submitterItemEl = this.closest('submitter-item')

    fields.forEach((field) => {
      const input = submitterItemEl.querySelector(`submitters-autocomplete[data-field="${field}"] input`)
      const textarea = submitterItemEl.querySelector(`submitters-autocomplete[data-field="${field}"] textarea`)

      if (input && item[field]) {
        input.value = item[field]
        input.dispatchEvent(new CustomEvent('linked-input.update', { bubbles: true }))
      }

      if (textarea && item[field]) {
        textarea.value = textarea.value.replace(/[^;,\s]+$/, item[field] + ' ')

        textarea.dispatchEvent(new Event('input', { bubbles: true }))
      }
    })
  }

  fetch = (text, resolve) => {
    const q = this.dataset.field === 'email'
      ? text.split(/[;,\s]+/).pop().trim()
      : text

    if (!q) {
      resolve([])

      return
    }

    this.abortFetch()

    const queryParams = new URLSearchParams({ q, field: this.dataset.field, _: Date.now().toString() })
    const url = '/submitters_autocomplete?' + queryParams.toString()

    this.fetchController = new AbortController()

    fetch(url, {
      cache: 'no-store',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: this.fetchController.signal
    }).then(async (resp) => {
      if (!resp.ok) {
        resolve([])

        return
      }

      const items = await resp.json()

      resolve(Array.isArray(items) ? items : [])
    }).catch((error) => {
      if (error.name !== 'AbortError') {
        resolve([])
      }
    })
  }

  abortFetch () {
    if (this.fetchController) {
      this.fetchController.abort()
      this.fetchController = null
    }
  }

  render = (item) => {
    const div = document.createElement('div')

    div.setAttribute('dir', 'auto')

    div.textContent = item[this.dataset.field]

    return div
  }

  get input () {
    return this.querySelector('input') || this.querySelector('textarea')
  }
}
